module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-bldg-apart-middle-0ab7bf3f07030dc9e6f77314c6ea5ec1.png";